import * as Yup from 'yup';

const schemaField = Yup.mixed().required('This field is required');

const stepFiveSchema = Yup.object().shape({
  primaryCity: schemaField,
  hometown: schemaField,
  geoPreferences: Yup.array().of(schemaField).min(1, 'Please select at least one location').required('This field is required'),
});

export default stepFiveSchema;
